module.exports = __webpack_public_path__ + "img/38793-159.4420ee5c.jpg";